import React from 'react'
import { toast } from 'react-semantic-toasts';
import { Accordion, Table } from 'semantic-ui-react';
import { useTextResources } from '../../language';
import { endpoint } from "../../api/http"


export const parseException = data => {
  let description = ""
  let correlationID = null
  let stackTrace = null
  if (data) {
    if (data.error) {
      data = data.error
    }
    if (data.ErrorMessage) {
      description = data.ErrorMessage
      correlationID = data.CorrelationID
    } else if (data.message) {
      description = data.message
    } else if (data.title) {
      description = data.title
    } else {
      description = data.toString()
    }
  }

  // Try parsing the error to see if it's an JSON object
  try {
    let exception = data.Exception ? JSON.parse(data.Exception) : JSON.parse(description)
    if (exception) {
      // Get the innermost exception
      const getInnerMost = exception => {
        if (exception.innerException) {
          return getInnerMost(exception.innerException)
        } else {
          return exception
        }
      }
      const parseExceptionInMessage = exception => {
        if (exception.Message || exception.exceptionMessage) {
          const message = exception.Message || exception.exceptionMessage
          try {
            const candidate = JSON.parse(message)
            if (candidate.innerException) {
              return parseExceptionInMessage(candidate.innerException)
            } else {
              return exception
            }
          } catch (error) {
            return exception
          }
        } else {
          return exception
        }
      }
      exception = parseExceptionInMessage(exception)
      exception = getInnerMost(exception)
      description = exception.Message || exception.exceptionMessage || exception.message
      stackTrace = exception.StackTraceString || exception.stackTrace || exception.StackTrace
      try {
        const candidate = JSON.parse(exception.Message)
        if (candidate.message) {
          description = candidate.message
        }
      } catch {
        // Do Nothing
      }
      
    }
  } catch {
    // Do Nothing
  }
  return {
    description ,
    correlationID,
    stackTrace
  }
}

const parseProblem = error=>{
  let result = "";
  if (error.detail){
    result = error.detail
  } else {
    for(var key in error.errors){
      result += `${key}: ${error.errors[key].map(x=>x + '\n')}`
    }
  }
  return result
}
/* eslint-disable react/prop-types */
const TitleCmp = ({ title, textNoTranslation }) => {
  const text = useTextResources()
  if (typeof (title) === "object") {
    title = title.message || title.title
  }

  return title ? text(title) + textNoTranslation : null
}

const DescCmp = ({ details }) => {
  const text = useTextResources()
  return <div style={{ minWidth: 300 }}>
    <div>{details?.description}</div>
    {(details?.correlationID || details?.stackTrace) && <div>
      <Accordion panels={[{
        key: "details",
        title: {
          content: text("Details")
        },
        content: {
          content: <div>
            <Table definition>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>CorrelationID</Table.Cell>
                  <Table.Cell>{details.correlationID}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Stack trace</Table.Cell>
                  <Table.Cell><div style={{ whiteSpace: "pre", maxHeight: 400, maxWidth: 700, overflow: "auto" }}>
                    {details.stackTrace}
                  </div></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
        }
      }]} />
    </div>}

  </div>
}

const TextWrapper = ({message, textNoTranslation = ''})=>{
  const text = useTextResources()
  return (
    <div style={{ minWidth: 300 }}>{`${text(
      message
    )} ${textNoTranslation}`}</div>
  );
}

/* eslint-enable react/prop-types */
const message = ({ data, title, textNoTranslation = '', ...rest }) => {
  if (data?.error?.type) {
    (title = data.error.title), (data = parseProblem(data.error));
  } else if (!data.success && !data.information) {
    data = parseException(data);
  }
  toast({
    title: <TitleCmp title={title} textNoTranslation={textNoTranslation} />,
    description:
      data?.success || data?.information ? (
        <TextWrapper message={data.success || data.message} />
      ) : (
        <DescCmp details={data} />
      ),
    size: 'small',
    animation: 'browse',
    onDismiss: () => {},
    onClick: () => {},
    ...rest,
  });
};

export const onInformation = ({
  title,
  messageTxt,
  onClick = () => {},
  ...rest
}) => {
  message({
    data: { information: true, message: messageTxt },
    title,
    time: 0,
    type: 'info',
    icon: 'sticky note',
    color: 'black',
    onClick,
    ...rest,
  });
};

export const onNote = ({ reservationNumber ,reservationId, hotelId }) => {
  const url = `${endpoint}/SharedServices/Notes/Index?entityId=${reservationId}&entityTypeId=1&$hotelId=${hotelId}`;
  function onClick() {
    window.open(url, '_blank');
  }
  const message = `RelevantNotesPertainingToThisReservationClickHere`;
  const extraDetails = `- Reservation #${reservationNumber}`;
  onInformation({
    title: 'Note',
    textNoTranslation: extraDetails,
    messageTxt: message,
    onClick,
  });
};


export const onSuccess = (title) => {
  message({
    title: "Success",
    data: {success: title || "SavedSuccessfully"},
    type: "success",
    icon: { className: "icon-check" },
    time: 3000
  })
}
export const onError = (error) => {
  message({
    title: "Error",
    data: error,
    type: "error",
    icon: { className: "icon-warning" },
    time: 0
  })
  console.error(error)
}

export const onWarning = (error) => {
  message({
    title: "Warning",
    data: error,
    type: "warning",
    icon: { className: "icon-broken-heart-silhouette-shape" },
    time: 10000
  })
}